<template>
    <div v-cloak v-if="show && companies.length" class="vatin-box">
        <span>{{ bundle.id_12055 }}</span>
        <a
            v-for="c in companies"
            :key="c.vatin"
            :href="watchUrl(c)"
        >
            {{ c.name }}
        </a>
    </div>
</template>

<script>
import Vue from "vue";

export default {
    name: "vatin-box",
    props: {
        advertorial: { type: Boolean, default: false },
        vatins: { type: Array, default: () => [] },
    },
    data() {
        return {
            companies: [],
            bundle: {
                id_12055: "Key numbers for:"
            }
        };
    },
    created() {
        Vue.$bundle("portal", this.bundle, (bundle) => {
            this.bundle = bundle;
        });
    },
    computed: {
        show() {
            return !this.advertorial && Array.isArray(this.vatins) && this.vatins.length > 0;
        }
    },
    mounted() {
        if (!this.show) return;
        this.vatins.forEach(vatin => this.load(vatin));
    },
    methods: {
        watchUrl(c) {
            return `${window.domain}/watch/${c.vatin}/${c.slug}`;
        },

        load(vatin) {
            // Guard: ensure required globals exist
            if (!window.CvrRestApi || !window.cvrRestApiAddress) return;

            window.CvrRestApi("Authorization", "Access").ajax({
                url: `${window.cvrRestApiAddress}/companies/${vatin}`,
                method: "GET",
                success: (response) => {
                    this.companies.push({
                        vatin,
                        name: response.name,
                        slug: (window.Vue && window.Vue.$slugUtil)
                            ? window.Vue.$slugUtil.withDashes(response.name)
                            : String(response.name || "")
                                .toLowerCase()
                                .trim()
                                .replace(/\s+/g, "-")
                                .replace(/[^a-z0-9]/g, "")
                    });
                },
                error: (err) => {
                    console.log(err);
                }
            });
        }
    }
};
</script>

<style scoped lang="less">
/* v-cloak support */
[v-cloak] { display: none; }
</style>